import { render, staticRenderFns } from "./ItemListLikeLayout.vue?vue&type=template&id=a70a0518&scoped=true"
import script from "./ItemListLikeLayout.vue?vue&type=script&lang=js"
export * from "./ItemListLikeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a0518",
  null
  
)

export default component.exports